import { Grid } from "@mui/material";
import { useMemo } from "react";
import ContentTitle from "../../../../components/Content/ContentTitle";
import { useLanguageContext } from "../../../../contexts/LanguageContext";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { INavigationLink } from "../../../../interfaces/INavigation";
import { useEnvironmentContext } from "../../../../contexts/EnvironmentContext";
import Iframe from "../../../../components/Iframe";
import Empty from "../../../../components/Empty";


const VacationCenterDashboard = (linkProps: INavigationLink) => {
    const { translate } = useLanguageContext();
    const { environment } = useEnvironmentContext();
    const { user, enterprise } = useAuthContext();


    const vacationCenterDashboardUrl = useMemo(() => {
        if (user && user.allowAllEnterprisesViewedInVacationCenterDashboard) {
            const vacationCenterDashboardUrl = environment.vacationCenterDashboardUrl;

            if (vacationCenterDashboardUrl && vacationCenterDashboardUrl.trim().length > 0) {
                return vacationCenterDashboardUrl;
            }
        }

        return enterprise?.vacationCenterDashboardUrl?.trim() ?? '';
    }, [user, environment, enterprise]);


    return (
        <>
            {
                vacationCenterDashboardUrl && vacationCenterDashboardUrl.length > 0 ? <>
                    <Iframe src={vacationCenterDashboardUrl} title={translate(linkProps.name)} className="position-absolute" />
                </> : <>
                    <Grid item xs={12} className='grid-header'>
                        <Grid item className='grid-title'>
                            <ContentTitle 
                                name={translate(linkProps.name)} 
                                description={enterprise?.name}
                                applyTranslation={false}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className='grid-content'>
                        <Grid item xs={12} className='paper-content display-flex alignitems-center justifycontent-center'>
                            <Empty text='noUrlConfiguredForPowerBiVisualization' />
                        </Grid>
                    </Grid>
                </>
            }
        </>
    );
}

export default VacationCenterDashboard;